import React from 'react';
import { Text } from '@mantine/core';

interface TableHeaderWrapperProps {
    readonly children: React.ReactNode;
    readonly className?: string;
}

export function TableHeaderWrapper(props: Readonly<TableHeaderWrapperProps>) {
    const { children, className } = props;
    return (
        <div className={`flex items-center gap-2 ${className ?? ''}`}>
            {children}
        </div>
    );
}

interface SimpleHeaderProps {
    readonly text: string;
}

function SimpleHeader({ text }: SimpleHeaderProps) {
    return (
        <TableHeaderWrapper>
            <div className="flex items-center h-full">
                <Text span className="flex items-center">
                    {text}
                </Text>
            </div>
        </TableHeaderWrapper>
    );
}

export { SimpleHeader };
